// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__258xX","item":"PaymentsMobile_item__lEL43","label":"PaymentsMobile_label__2q2NK","amount":"PaymentsMobile_amount__Sq54c"};